import api from './authService';
import { Opportunity } from '../types';

export type OpportunityInput = Omit<
  Opportunity,
  | 'id'
  | 'created_at'
  | 'updated_at'
  | 'client_name'
  | 'commercial_owner_name'
  | 'proposed_pm_name'
  | 'office_name'
  | 'proposal_project_id'
  | 'awarded_project_id'
>;

export type LinkProjectKind = 'proposal' | 'awarded';

const opportunitiesService = {
  async listOpportunities(): Promise<Opportunity[]> {
    const response = await api.get<Opportunity[]>('/opportunities');
    return response.data;
  },

  async createOpportunity(input: OpportunityInput): Promise<Opportunity> {
    const response = await api.post<Opportunity>('/opportunities', input);
    return response.data;
  },

  async updateOpportunity(id: string, input: OpportunityInput): Promise<Opportunity> {
    const response = await api.put<Opportunity>(`/opportunities/${id}`, input);
    return response.data;
  },

  async linkProject(id: string, kind: LinkProjectKind, projectId: number): Promise<Opportunity> {
    const response = await api.post<Opportunity>(`/opportunities/${id}/link-project`, {
      kind,
      project_id: projectId,
    });
    return response.data;
  },

  async getLatestOfferReference(id: string): Promise<string | null> {
    const response = await api.get<{ reference_nd_offer: string | null }>(
      `/opportunities/${id}/latest-offer-reference`,
    );
    return response.data.reference_nd_offer;
  },

  async deleteOpportunity(id: string): Promise<void> {
    await api.delete(`/opportunities/${id}`);
  },
};

export default opportunitiesService;
